type StoreLike = {
  getState: () => any;
  subscribe: (listener: () => void) => () => void;
  dispatch: (action: any) => any;
};

let storeRef: StoreLike | null = null;

export const setStoreAccessor = (store: StoreLike) => {
  storeRef = store;
};

export const getStore = () => {
  return storeRef;
};

export const getStoreState = () => {
  return storeRef?.getState?.();
};
